import React, { Component } from "react";
import PropTypes from "prop-types";
import translate from "react-i18next/dist/commonjs/translate";
import severityLevel from "../severityConfig";

class Legend extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { labels, t } = this.props;
    return (
      <div className="row legend-row">
        <div className="legend-column-wrapper">
          <div className={`legend-item low-severity`}>
            <h3>{t("lowSeverity")}</h3>
            <p>{labels.lowSeverity.count}</p>
          </div>
          <div className={`legend-item medium-severity`}>
            <h3>{t("mediumSeverity")}</h3>
            <p>{labels.mediumSeverity.count}</p>
          </div>
          <div className={`legend-item high-severity`}>
            <h3>{t("highSeverity")}</h3>
            <p>{labels.highSeverity.count}</p>
          </div>
        </div>
      </div>
    );
  }
}

Legend.propTypes = {
  labels: PropTypes.object.isRequired
};

export default translate("translations")(Legend);



// WEBPACK FOOTER //
// ./src/common/chart/Legend.js